import { render, staticRenderFns } from "./answer_done.vue?vue&type=template&id=69accaf9&scoped=true"
import script from "./answer_done.vue?vue&type=script&lang=js"
export * from "./answer_done.vue?vue&type=script&lang=js"
import style0 from "./answer_done.vue?vue&type=style&index=0&id=69accaf9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69accaf9",
  null
  
)

export default component.exports